/* GCR · YouTube: carosello video (manuale o automatico dal canale) */
if (!customElements.get('gcr-yt-gallery')) {
  customElements.define('gcr-yt-gallery', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-yt-rail]');
      this.modal = this.querySelector('[data-yt-modal]');
      this.frame = this.querySelector('[data-yt-frame]');
      const step = (dir) => this.rail.scrollBy({ left: dir * (this.rail.firstElementChild?.offsetWidth || 300) + dir * 16, behavior: 'smooth' });
      this.querySelector('[data-yt-prev]')?.addEventListener('click', () => { step(-1); this.stop(); });
      this.querySelector('[data-yt-next]')?.addEventListener('click', () => { step(1); this.stop(); });
      this.rail.addEventListener('pointerdown', () => this.stop(), { passive: true });
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-yt-id]');
        if (t && t.dataset.ytId) this.open(t.dataset.ytId);
        if (e.target.closest('[data-yt-close]') || e.target === this.modal) this.close();
      });
      this.modal.addEventListener('close', () => { this.frame.innerHTML = ''; });
      // scorrimento automatico leggero, solo quando la sezione è visibile
      if (this.dataset.autoscroll === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
        const every = Number(this.dataset.interval) || 6000;
        this.io = new IntersectionObserver(([en]) => {
          clearInterval(this.timer);
          if (en.isIntersecting && !this.stopped) this.timer = setInterval(() => {
            const r = this.rail;
            if (r.scrollLeft + r.clientWidth >= r.scrollWidth - 4) r.scrollTo({ left: 0, behavior: 'smooth' }); else step(1);
          }, every);
        });
        this.io.observe(this);
      }
    }
    stop() { this.stopped = true; clearInterval(this.timer); }
    open(id) {
      this.stop();
      this.frame.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0" title="Video YouTube" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
      this.modal.showModal();
    }
    close() { this.modal.close(); }
    disconnectedCallback() { clearInterval(this.timer); this.io?.disconnect(); }
  });
}

/* Canale automatico: legge gli ultimi video con la YouTube Data API v3.
   - parte solo quando la sezione sta per entrare nello schermo
   - risultato salvato nel browser per qualche ora: poche chiamate, quota al sicuro
   - 3 chiamate (canale, ultimi caricamenti, numeri dei video) = 3 unità di quota */
if (!customElements.get('gcr-yt-channel')) {
  customElements.define('gcr-yt-channel', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      const go = () => { if (!this.started) { this.started = true; this.load(); } };
      if (!('IntersectionObserver' in window)) return go();
      this.io = new IntersectionObserver((en) => { if (en.some((e) => e.isIntersecting)) { this.io.disconnect(); go(); } }, { rootMargin: '800px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { this.io?.disconnect(); }
    async load() {
      const key = (this.dataset.key || '').trim();
      const ch = (this.dataset.channel || '').trim();
      const n = Math.min(24, Math.max(1, Number(this.dataset.count) || 9));
      if (!key || !ch) return this.fail('Inserisci API key e canale nelle impostazioni della sezione.');
      const cacheKey = `gcr-yt:${ch}:${n}:${this.dataset.shorts}`;
      const ttl = (Number(this.dataset.cacheHours) || 6) * 3600e3;
      try {
        const c = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (c && Date.now() - c.t < ttl && !window.Shopify?.designMode) return this.render(c.d);
      } catch (e) {}
      try {
        const api = (path, params) => fetch(`https://www.googleapis.com/youtube/v3/${path}?${new URLSearchParams({ ...params, key })}`).then((r) => r.json()).then((j) => { if (j.error) throw new Error(j.error.message); return j; });
        const idParam = ch.startsWith('UC') ? { id: ch } : { forHandle: ch.startsWith('@') ? ch : '@' + ch };
        const chRes = await api('channels', { part: 'snippet,statistics,contentDetails', ...idParam });
        const c = chRes.items?.[0];
        if (!c) throw new Error('Canale non trovato');
        const uploads = c.contentDetails.relatedPlaylists.uploads;
        const pl = await api('playlistItems', { part: 'contentDetails', playlistId: uploads, maxResults: String(Math.min(50, n * 2 + 6)) });
        const ids = (pl.items || []).map((i) => i.contentDetails.videoId).join(',');
        const vs = ids ? await api('videos', { part: 'snippet,statistics,contentDetails', id: ids }) : { items: [] };
        const secs = (d) => { const m = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/.exec(d || '') || []; return (+m[1] || 0) * 3600 + (+m[2] || 0) * 60 + (+m[3] || 0); };
        let videos = (vs.items || []).filter((v) => v.snippet.liveBroadcastContent === 'none');
        if (this.dataset.shorts !== 'true') videos = videos.filter((v) => secs(v.contentDetails.duration) > 70);
        const t = (s) => s.thumbnails.maxres || s.thumbnails.standard || s.thumbnails.high || s.thumbnails.medium || s.thumbnails.default;
        const data = {
          channel: {
            title: c.snippet.title,
            avatar: c.snippet.thumbnails?.medium?.url || c.snippet.thumbnails?.default?.url || '',
            url: c.snippet.customUrl ? `https://www.youtube.com/${c.snippet.customUrl}` : `https://www.youtube.com/channel/${c.id}`,
            subs: c.statistics.hiddenSubscriberCount ? null : +c.statistics.subscriberCount,
            videos: +c.statistics.videoCount,
            views: +c.statistics.viewCount
          },
          items: videos.slice(0, n).map((v) => ({
            id: v.id,
            title: v.snippet.title,
            desc: v.snippet.description.split('\n').find((l) => l.trim()) || '',
            date: v.snippet.publishedAt,
            thumb: t(v.snippet)?.url || `https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`,
            views: +v.statistics.viewCount || 0,
            likes: v.statistics.likeCount != null ? +v.statistics.likeCount : null,
            comments: v.statistics.commentCount != null ? +v.statistics.commentCount : null
          }))
        };
        try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
        this.render(data);
      } catch (err) {
        // se la chiamata fallisce ma c'è una copia vecchia, meglio quella che niente
        try { const c = JSON.parse(localStorage.getItem(cacheKey) || 'null'); if (c) return this.render(c.d); } catch (e) {}
        this.fail(err.message);
      }
    }
    fail(msg) {
      this.classList.add('is-error');
      const box = this.querySelector('[data-yt-error]');
      if (box && window.Shopify?.designMode) { box.hidden = false; box.textContent = 'YouTube: ' + msg; }
      if (!window.Shopify?.designMode) this.querySelector('[data-yt-fallback]')?.removeAttribute('hidden');
    }
    render(d) {
      const nf = new Intl.NumberFormat('it-IT');
      const df = new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
      const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
      const head = this.querySelector('[data-yt-head]');
      if (head) {
        const av = head.querySelector('[data-yt-avatar]');
        if (av && d.channel.avatar) { av.src = d.channel.avatar; av.hidden = false; }
        const nm = head.querySelector('[data-yt-name]');
        if (nm && !nm.textContent.trim()) nm.textContent = d.channel.title;
        const st = head.querySelector('[data-yt-stats]');
        if (st) st.textContent = [d.channel.subs != null ? `${nf.format(d.channel.subs)} iscritti` : '', `${nf.format(d.channel.videos)} video`, `${nf.format(d.channel.views)} visualizzazioni`].filter(Boolean).join(' · ');
        const sub = head.querySelector('[data-yt-sub]');
        if (sub && !sub.getAttribute('href')) sub.href = d.channel.url + '?sub_confirmation=1';
        head.hidden = false;
      }
      const stats = this.dataset.stats === 'true';
      const desc = this.dataset.desc === 'true';
      const rail = this.querySelector('[data-yt-rail]');
      rail.innerHTML = d.items.map((v) => {
        const parts = [`${nf.format(v.views)} visualizzazioni`];
        if (v.likes != null) parts.push(`${nf.format(v.likes)} Mi piace`);
        if (v.comments != null) parts.push(`${nf.format(v.comments)} commenti`);
        return `<article class="gcr-yt__card">
          <button class="gcr-yt__thumb" type="button" data-yt-id="${esc(v.id)}" aria-label="Guarda: ${esc(v.title)}">
            <img src="${esc(v.thumb)}" alt="" loading="lazy" decoding="async" width="480" height="270">
            <span class="gcr-yt__play" aria-hidden="true"><svg viewBox="0 0 68 48" width="56" height="40"><path d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.3.3 34 .3 34 .3s-21.3 0-26.6 1.4a8.5 8.5 0 0 0-6 6C0 13 0 24 0 24s0 11 1.4 16.3a8.5 8.5 0 0 0 6 6C12.7 47.7 34 47.7 34 47.7s21.3 0 26.6-1.4a8.5 8.5 0 0 0 6-6C68 35 68 24 68 24s0-11-1.4-16.3z" fill="#FF0000"/><path d="M27 34l18-10-18-10z" fill="#fff"/></svg></span>
          </button>
          <div class="gcr-yt__meta">
            <div class="gcr-yt__row"><h3 class="gcr-yt__title">${esc(v.title)}</h3><time class="gcr-yt__date" datetime="${esc(v.date)}">${df.format(new Date(v.date))}</time></div>
            ${desc && v.desc ? `<p class="gcr-yt__desc">${esc(v.desc)}</p>` : ''}
            ${stats ? `<p class="gcr-yt__stats">${parts.join(' · ')}</p>` : ''}
          </div>
        </article>`;
      }).join('');
      this.classList.add('is-ready');
      this.querySelector('[data-yt-nav]')?.toggleAttribute('hidden', d.items.length < 2);
    }
  });
}
